import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Api from '../services/api/api';
import NitroButton from './parts/NitroButton';

const Home = () => {

  let navigate = useNavigate();
  const [lookUpStatus, setLookUpStatus] = useState();

  const { register, handleSubmit, watch, reset, formState: { isValid, errors } } = useForm({
    mode: 'onChange',
    defaultValues: {
      nitroTextInput: '', // this is required for the inline error message
    }
  });
  //const formData = watch(); // The 'live' data
  const onSubmit = (data) => {
    // need to check if the code entered is valid, by searching the api
    if (data.nitroTextInput) {
      let resourceApi = new Api();
      resourceApi.get('survey/' + data.nitroTextInput)
        .then(res => res.json())
        .then((response) => {
          console.log('response from api', response);
          if (response && response.success === "success" && response.payload) {
            setLookUpStatus('')
            navigate("./" + data.nitroTextInput, { replace: true });
          } else {
            setLookUpStatus('Sorry, the ID ' + data.nitroTextInput + ' is invalid')
            reset()
          }
        })
        .catch((error) => {
          setLookUpStatus('Sorry, the ID ' + data.nitroTextInput + ' is invalid')
          reset()
        });
    }

  }

  const validationOptions = {};

    validationOptions.required = 'This field is required.';

    validationOptions.minLength = {
      value: 1,
      message: 'This field is required.'
    }

    validationOptions.maxLength = {
      value: 10,
      message: 'The ID should be less than 10 characters.'
    }


  return (
    <div className="w-screen min-h-screen pageStyle1">

      <div className="container lg">
        <div className="min-h-screen mx-auto flex flex-col px-8 pt-24 pb-16">
          <header>
            <h1 className="font-black text-center text-2xl md:text-5xl">Enter your survey ID number:</h1>
          </header>
          <div className="grow py-12">
            <div className="container max-w-lg">
              <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col space-y-8">
              <input
                type="text"
                {...register('nitroTextInput', validationOptions)}
                placeholder="Enter your survey ID"
                className="
                      w-full
                      px-3
                      py-1.5
                      text-nitro-slate
                      text-base
                      font-normal
                      rounded
                      transition
                      ease-in-out
                      m-0
                      focus:outline-none
                    ">
              </input>
              <p className="text-xs">{lookUpStatus}<br /> {errors.nitroTextInput?.message}</p>
                <p className='text-xs'>Hint: At present, the only valid ID is m88wj3y5pa</p>

              </form>
            </div>
          </div>
          <NitroButton label="Go" formIsValid={isValid} onClick={handleSubmit(onSubmit)} />

        </div>
      </div>
    </div>

  );

}

export default Home;
